import ResizeHandler from './resize-handler';

export default class AdminbarHandler {
    constructor(headerBreakpoint) {
        let adminBarCondition =  'document.querySelector("#wpadminbar") !== null';
        let adminBarClass = 'push-down-for-adminbar';
        let adminBarBreakpoint = 782;

        new ResizeHandler([
            {
                width: adminBarBreakpoint,
                selector: '.header-navigation',
                addClass: adminBarClass,
                extraCondition: adminBarCondition,
            },
            {
                width: headerBreakpoint,
                selector: '.header-navigation',
                addClass: adminBarClass,
                extraCondition: adminBarCondition,
                direction: 'down'
            },
            {
                width: headerBreakpoint,
                selector: '.header-navigation',
                removeClass: adminBarClass,
                extraCondition: adminBarCondition
            },
            {
                width: adminBarBreakpoint,
                selector: '.header-navigation',
                removeClass: adminBarClass,
                direction: 'down'
            },
        ]);
    }
}